import React from 'react';

const ImageSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 to-yellow-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Large Banner Text */}
          <div className="bg-gradient-to-r from-orange-400 to-red-400 rounded-2xl p-8 mb-8 shadow-lg">
            <h2 className="text-4xl lg:text-5xl font-bold text-white text-center">
              台灣及全球各地活動
            </h2>
          </div>
          
          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left: GIF Image */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">台灣在地活動</h3>
              <div className="rounded-xl overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_instant-website-93/artifacts/02kgjkej_%E6%98%8E%E6%82%85%E5%BF%83%E5%89%B5%E5%8F%B0%E7%81%A3%E6%B4%BB%E5%8B%95.gif"
                  alt="明悅心創台灣在地活動"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Right: GIF Image */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">全球各地活動</h3>
              <div className="rounded-xl overflow-hidden shadow-md">
                <img 
                  src="https://customer-assets.emergentagent.com/job_instant-website-93/artifacts/5xx7ncei_%E6%98%8E%E6%82%85%E5%BF%83%E5%89%B5%E5%85%A8%E7%90%83%E6%B4%BB%E5%8B%95.gif"
                  alt="明悅心創全球各地活動"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageSection;
